<template>
  <div>
    <div class="section-header">
      <div class="section-headers">Cohorts</div>
      <router-link to="/cohorts/new">New Cohort</router-link>
    </div>
    <div class="card card--white">
      <div class="card card--container" v-for="cohort in cohorts" :key="cohort.id">
        <router-link class="card-text-header" :to="{name: 'cohortDetail', params: {id: cohort.id}}">{{ cohort.name }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import dataStore from "@/services/api/store";
const STORE_COHORT = "CoachCohort";

export default {
  data() {
    return {
      cohorts: []
    };
  },
  created() {
    dataStore.findAll(STORE_COHORT, {}, { force: true }).then(result => {
      this.cohorts = result;
    });
  }
};
</script>
